'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Stats = exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _auth = require('redux/modules/auth');

var _messages = require('redux/modules/messages');

var _components = require('components');

var _translations = require('translations');

var _translations2 = _interopRequireDefault(_translations);

var _reduxConnect = require('redux-connect');

var _reactRedux = require('react-redux');

var _account = require('redux/modules/account');

var _reachHistory = require('../../../helpers/reachHistory');

var _useBasename = require('../../../helpers/useBasename');

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./PushFile.scss');

var PushFile = (_dec = (0, _reduxConnect.asyncConnect)([{
	key: "auth",
	promise: function promise(_ref) {
		var _ref$store = _ref.store,
		    dispatch = _ref$store.dispatch,
		    getState = _ref$store.getState;

		if (!(0, _auth.isLoaded)(getState())) {
			return dispatch((0, _auth.load)());
		}
		return null;
	}
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
	return { account: state.account.data, auth: state.auth };
}, {
	messageSendFile: _messages.messageSendFile,
	messageUpdateFileStats: _messages.messageUpdateFileStats,
	messageConfirmSendFile: _messages.messageConfirmSendFile,
	push: _reachHistory.push
}), _dec(_class = _dec2(_class = function (_Component) {
	(0, _inherits3.default)(PushFile, _Component);

	function PushFile(props) {
		(0, _classCallCheck3.default)(this, PushFile);

		var _this = (0, _possibleConstructorReturn3.default)(this, (PushFile.__proto__ || (0, _getPrototypeOf2.default)(PushFile)).call(this, props));

		_this.changeFlagStatus = function () {
			_this.setState({ flag: false });
		};

		_this.state = {
			stats: null,
			variables: null,
			filename: null,
			flag: false,
			file_data: null,
			created_byUser: _this.props.auth.data.user.email,
			fileInfo: null,
			messageUpdateFileStats: _this.props.messageUpdateFileStats,
			isMessageInFile: false,
			fileContacts: [],
			messageConfirmSendFile: _this.props.messageConfirmSendFile,
			redirectTo: _this.props.push
		};
		return _this;
	}

	(0, _createClass3.default)(PushFile, [{
		key: 'onFileAdded',
		value: function () {
			var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(filename, formData) {
				var fileWithMeta, flag, fileInfo;
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								fileWithMeta = formData;
								flag = false;

								fileWithMeta.append('created_by', this.state.created_byUser);
								_context.next = 5;
								return this.props.messageSendFile(fileWithMeta, 'email');

							case 5:
								fileInfo = _context.sent;

								if (fileInfo) {
									flag = true;
								}
								this.setState({ filename: filename, flag: flag, fileInfo: fileInfo });

							case 8:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function onFileAdded(_x, _x2) {
				return _ref2.apply(this, arguments);
			}

			return onFileAdded;
		}()
	}, {
		key: 'readFileData',
		value: function readFileData(dataFile) {
			if (dataFile.length > 0) {
				var fileHeader = dataFile[0];
				var variables = [];
				var isMessageInFile = false;
				for (var key in fileHeader) {
					if (key !== 'token') {
						key = key.replace(/[^a-z^A-Z^0-9\^_]+/g, "_");
						variables.push(key);
					}
					if (key == 'mensaje') {
						isMessageInFile = true;
					}
				}
				this.setState({ variables: variables, isMessageInFile: isMessageInFile, fileContacts: dataFile });
			}
		}
	}, {
		key: 'render',
		value: function render() {
			return this.state.flag ? _react2.default.createElement(Stats, {
				data: this.state }) : _react2.default.createElement(
				'div',
				{ className: styles.pushFileContainer },
				_react2.default.createElement(
					'div',
					{ className: styles.selectorDropZone },
					_react2.default.createElement(
						'div',
						{ className: styles.hintsContainer },
						_react2.default.createElement(
							'div',
							{ className: styles.headerMen },
							'Instrucciones'
						),
						_react2.default.createElement(
							'div',
							{ className: styles.instructionContainer },
							_react2.default.createElement(
								'div',
								{ className: styles.hintContainer },
								_react2.default.createElement('img', { className: styles.exampleIcon, src: (0, _useBasename2.default)('/static/csvExample.svg') }),
								_react2.default.createElement(
									'div',
									{ className: styles.headerContainer },
									(0, _translations2.default)('CSV HINT')
								)
							),
							_react2.default.createElement(
								'div',
								{ className: styles.hintContainer },
								_react2.default.createElement('img', { className: styles.exampleIcon, src: (0, _useBasename2.default)('/static/contactExample.svg') }),
								_react2.default.createElement(
									'div',
									{ className: styles.headerContainer },
									(0, _translations2.default)('EMAIL HINT')
								)
							),
							_react2.default.createElement(
								'div',
								{ className: styles.hintContainer },
								_react2.default.createElement('img', { className: styles.exampleIcon, src: (0, _useBasename2.default)('/static/messageExample.svg') }),
								_react2.default.createElement(
									'div',
									{ className: styles.headerContainer },
									(0, _translations2.default)('EMAIL VARIABLES')
								)
							),
							_react2.default.createElement(
								'a',
								{ href: 'https://s3.amazonaws.com/public-im-resources/prueba-token-file.csv', download: true },
								_react2.default.createElement('img', { style: { height: '90px' }, src: (0, _useBasename2.default)('/static/downloadFile.svg') }),
								_react2.default.createElement(
									'div',
									{ className: styles.downloadHeader },
									(0, _translations2.default)('FILE TEMPLATE DOWNLOAD')
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: styles.dropZoneHolder },
						_react2.default.createElement(_components.DropZone, {
							style: { height: '100%', width: '510px' },
							onFileAdded: this.onFileAdded.bind(this),
							readFileData: this.readFileData.bind(this) })
					)
				)
			);
		}
	}]);
	return PushFile;
}(_react.Component)) || _class) || _class);
exports.default = PushFile;

var Stats = exports.Stats = function (_React$Component) {
	(0, _inherits3.default)(Stats, _React$Component);

	function Stats(props) {
		(0, _classCallCheck3.default)(this, Stats);

		var _this2 = (0, _possibleConstructorReturn3.default)(this, (Stats.__proto__ || (0, _getPrototypeOf2.default)(Stats)).call(this, props));

		_this2.addVariable = function (key) {
			var messageTextArea = _this2.textAreaRef.current;
			var index = messageTextArea.selectionStart;
			var oldMessage = _this2.state.message || "";
			var newMessage = oldMessage.slice(0, index) + '{' + key + '}' + oldMessage.slice(index);
			_this2.setState({ message: newMessage });
		};

		_this2.state = {
			variables: _this2.props.data.variables,
			filename: _this2.props.data.filename,
			message: null,
			fileStats: null,
			isMessageInFile: _this2.props.data.isMessageInFile,
			fileContacts: _this2.props.data.fileContacts
		};
		_this2.textAreaRef = _react2.default.createRef();
		return _this2;
	}

	(0, _createClass3.default)(Stats, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this3 = this;

			var variables = [];
			var stringVariables = this.state.variables;
			if (!this.state.isMessageInFile) {
				var _loop = function _loop(key) {
					variables.push(_react2.default.createElement(_components.Button, {
						className: styles.variablesOptions,
						name: _this3.state.variables[key],
						color: 'blue',
						onClick: function onClick() {
							return _this3.addVariable(stringVariables[key]);
						} }));
				};

				for (var key in stringVariables) {
					_loop(key);
				}
				this.setState({ variables: variables });
			}
		}
	}, {
		key: 'getMessage',
		value: function getMessage(message) {
			this.setState({ message: message });
		}
	}, {
		key: 'goBack',
		value: function goBack() {
			this.props.changeFlagStatus();
		}
	}, {
		key: 'getFileStats',
		value: function () {
			var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
				var _props$data, fileInfo, messageUpdateFileStats, isMessageInFile, file_data, fileStats;

				return _regenerator2.default.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:
								_props$data = this.props.data, fileInfo = _props$data.fileInfo, messageUpdateFileStats = _props$data.messageUpdateFileStats;
								isMessageInFile = this.state.isMessageInFile;
								file_data = {};

								if (isMessageInFile) {
									file_data = {
										_id: fileInfo._id,
										file_format: 'PUSH_MESSAGE',
										channel_type: 'PUSH'
									};
								} else {
									file_data = {
										_id: fileInfo._id,
										file_format: 'PUSH_VARS',
										channel_type: 'PUSH',
										message: this.state.message
									};
								}
								_context2.next = 6;
								return messageUpdateFileStats(file_data, 'email');

							case 6:
								fileStats = _context2.sent;

								this.setState({ fileStats: fileStats });

							case 8:
							case 'end':
								return _context2.stop();
						}
					}
				}, _callee2, this);
			}));

			function getFileStats() {
				return _ref3.apply(this, arguments);
			}

			return getFileStats;
		}()
	}, {
		key: 'sendMessage',
		value: function () {
			var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
				var _props$data2, fileInfo, messageConfirmSendFile, redirectTo, isMessageInFile, file_data, fileStats;

				return _regenerator2.default.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_props$data2 = this.props.data, fileInfo = _props$data2.fileInfo, messageConfirmSendFile = _props$data2.messageConfirmSendFile, redirectTo = _props$data2.redirectTo;
								isMessageInFile = this.state.isMessageInFile;
								file_data = {};

								if (isMessageInFile) {
									file_data = {
										_id: fileInfo._id,
										file_format: 'PUSH_MESSAGE',
										channel_type: 'PUSH'
									};
								} else {
									file_data = {
										_id: fileInfo._id,
										file_format: 'PUSH_VARS',
										channel_type: 'PUSH',
										message: this.state.message
									};
								}
								_context3.next = 6;
								return messageConfirmSendFile(file_data, 'email');

							case 6:
								fileStats = _context3.sent;

								if (fileStats) {
									redirectTo({
										pathname: '/success',
										state: {
											goTo: '/push/file',
											goToModal: false,
											message: 'Se envio correctamente el mensaje',
											modal: true,
											returnTo: '/push'
										}
									});
								} else {
									redirectTo({
										pathname: '/fail',
										state: {
											goTo: '/push/file',
											goToModal: false,
											message: 'Ha ocurrido un error',
											modal: true,
											returnTo: '/push'
										}
									});
								}

							case 8:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, this);
			}));

			function sendMessage() {
				return _ref4.apply(this, arguments);
			}

			return sendMessage;
		}()
	}, {
		key: 'renderVariables',
		value: function renderVariables() {
			return _react2.default.createElement(
				'div',
				{ style: { height: '100%' } },
				_react2.default.createElement(
					'div',
					{ className: styles.variablesContainer },
					_react2.default.createElement(
						'span',
						{ style: { marginLeft: '4%' } },
						' Variables disponibles en archivo '
					),
					_react2.default.createElement(
						'div',
						{ className: styles.variableFromState },
						this.state.variables
					)
				)
			);
		}
	}, {
		key: 'renderActionButtons',
		value: function renderActionButtons() {
			var _this4 = this;

			return _react2.default.createElement(
				'div',
				null,
				this.state.fileStats ? _react2.default.createElement(_components.Button, {
					className: styles.sendMessage,
					color: 'blue',
					name: 'Enviar ahora',
					onClick: function onClick() {
						return _this4.sendMessage();
					} }) : _react2.default.createElement(_components.Button, {
					className: styles.sendMessage,
					color: 'blue',
					name: 'Datos del archivo',
					style: { width: 'auto' },
					onClick: function onClick() {
						return _this4.getFileStats();
					} })
			);
		}
	}, {
		key: 'renderWithMessageIn',
		value: function renderWithMessageIn() {
			var fileContacts = this.state.fileContacts;

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{ className: styles.messageInContainer },
					fileContacts.map(function (contact) {
						return _react2.default.createElement(
							'div',
							{ className: styles.messageInArea },
							_react2.default.createElement(
								'div',
								{ className: styles.messageText },
								_react2.default.createElement(
									'div',
									{ className: styles.display },
									contact.telefono
								),
								_react2.default.createElement(
									'h1',
									null,
									contact.mensaje
								)
							)
						);
					})
				),
				this.renderFileStats(),
				this.renderActionButtons()
			);
		}
	}, {
		key: 'renderWithNoMessageIn',
		value: function renderWithNoMessageIn() {
			var _this5 = this;

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement('textarea', {
					ref: this.textAreaRef,
					className: styles.messageArea,
					onChange: function onChange(event) {
						return _this5.getMessage(event.target.value);
					},
					value: this.state.message
				}),
				this.renderFileStats(),
				this.renderActionButtons()
			);
		}
	}, {
		key: 'renderFileStats',
		value: function renderFileStats() {
			return _react2.default.createElement(
				'div',
				{ className: styles.statsArea },
				_react2.default.createElement(
					'div',
					{ className: styles.statsInfo },
					_react2.default.createElement(
						'div',
						{ className: styles.statsInfoColumn },
						_react2.default.createElement(
							'div',
							{ className: styles.borderBottom },
							' L\xEDneas Correctas '
						),
						_react2.default.createElement(
							'div',
							{ className: styles.borderBottom },
							' L\xEDneas con error '
						),
						_react2.default.createElement(
							'div',
							{ className: styles.borderBottom },
							' L\xEDneas duplicadas '
						),
						_react2.default.createElement(
							'div',
							null,
							' L\xEDneas con formato inv\xE1lido '
						)
					),
					_react2.default.createElement(
						'div',
						{ className: styles.statsResultsColumn },
						_react2.default.createElement(
							'div',
							{ className: styles.borderBottom },
							this.state.fileStats ? this.state.fileStats.lines_ok : 0
						),
						_react2.default.createElement(
							'div',
							{ className: styles.borderBottom },
							this.state.fileStats ? this.state.fileStats.lines_error.total_error : 0
						),
						_react2.default.createElement(
							'div',
							{ className: styles.borderBottom },
							this.state.fileStats ? this.state.fileStats.lines_error.duplicates : 0
						),
						_react2.default.createElement(
							'div',
							null,
							this.state.fileStats ? this.state.fileStats.lines_error.invalid_format : 0
						)
					)
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this6 = this;

			return _react2.default.createElement(
				'div',
				{ className: styles.statsContainer },
				_react2.default.createElement(
					'div',
					{ className: styles.fileInfo },
					_react2.default.createElement(
						'div',
						{ className: styles.fileInfoHeader },
						_react2.default.createElement(
							'span',
							null,
							'Informaci\xF3n del archivo'
						),
						_react2.default.createElement(
							'div',
							{ className: styles.imgContainer },
							_react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/file.svg') }),
							_react2.default.createElement(
								'span',
								null,
								this.state.filename
							)
						),
						_react2.default.createElement(_components.Button, {
							className: styles.buttonContainer,
							color: 'lightGreen',
							name: 'Cambiar archivo',
							onClick: function onClick() {
								return _this6.goBack();
							} })
					),
					this.state.isMessageInFile ? null : this.renderVariables()
				),
				_react2.default.createElement(
					'div',
					{ className: styles.fileStats },
					_react2.default.createElement(
						'div',
						{ className: styles.messageInfo },
						_react2.default.createElement(
							'a',
							{
								style: { marginLeft: '5%' },
								className: this.state.isMessageInFile ? styles.isActive : null },
							' El mensaje viene en el archivo '
						),
						_react2.default.createElement(
							'a',
							{
								style: { marginRight: '5%' },
								className: this.state.isMessageInFile ? null : styles.isActive },
							' Redactar el mensaje '
						)
					),
					this.state.isMessageInFile ? this.renderWithMessageIn() : this.renderWithNoMessageIn()
				)
			);
		}
	}]);
	return Stats;
}(_react2.default.Component);